import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import styles from './Flex.css'

export default class Flex extends React.Component {

  render() {
    let { className, variant, direction, wrap, inline, justify, align, alignContent, style, ...rest } = this.props
    if ( direction || wrap || inline != null || justify || align || alignContent ) {
      style = style == null ? {} : { ...style }
      if ( direction ) { style.flexDirection = direction }
      if ( inline ) { style.display = inline ? 'inline-flex' : 'flex' }
      if ( wrap ) { style.flexWrap = wrap }
      if ( justify ) { style.justifyContent = justify }
      if ( align ) { style.alignItems = align }  
      if ( alignContent ) { style.alignContent = alignContent }  
    }
    return (
      <div className={classNames( styles.flex, variant && styles[`flex-${variant}`], className )} style={style} {...rest}>
        { this.props.children }
      </div>
    )
  }
}

class Layout extends React.Component {
  render() {
    const { children, grow, shrink, basis, align, justify, style } = this.props
    const c = React.Children.count( children )
    if ( c == 0 ) {
      return null
    } if ( c > 1 ) {
      throw new Error( 'Flex.Layout supports only one child' )
    } 
    let elem = React.Children.only( children )
    const flex = { style : style || {} }
    if ( grow != null ) {
      flex.style.flex = `${grow} ${shrink || ''} ${basis || ''}`.trim()
    } else if ( shrink != null || basis != null || align != null ) {
      if ( align ) { flex.style.alignSelf = align }
      if ( shrink ) { flex.style.flexShrink = shrink }
      if ( basis ) { flex.style.flexBasis = basis }
    } else {
      return elem
    }

    let cStyle = c.props && c.props.style
    cStyle = cStyle ? { ...cStyle, ...flex } : flex
    elem = React.cloneElement( elem, cStyle )
    return elem
  }
}

Flex.Layout = Layout
